<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="icons/status/merge" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <circle id="Oval" fill="#002940" cx="12" cy="12" r="10"></circle>
        <path d="M12,5 L9.08333333,7.91666667 L11.1666667,7.91666667 L11.1666667,11.7416667 L7,15.9083333 L8.175,17.0833333 L12.8333333,12.425 L12.8333333,7.91666667 L14.9166667,7.91666667 L12,5 Z M14.5,13.4083333 L13.325,14.5833333 L15.825,17.0833333 L17,15.9083333 L14.5,13.4083333 Z" id="Shape" fill="#FFFFFF" fill-rule="nonzero"></path>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: 'DsTicketMergedIcon',
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-ticket-merged-icon.vue